import { DQL_SPECIAL_CHARACTERS } from "../enumerators/searchEngine";

export function addNonBreakingSpaces(str) {
  return str.replace(/ /g, "\u00a0");
}

export function arrWithDuplicates(arr) {
  return !!arr.filter((item, index) => arr.indexOf(item) !== index).length;
}

export function toCamelCase(kebabCase) {
  return kebabCase.replace(/-./g, (word) => word[1].toUpperCase());
}

export function capitalizeString(s) {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function decodeBase64(value) {
  return Buffer.from(value, "base64").toString();
}

export function encodeBase64(value) {
  return Buffer.from(value).toString("base64");
}

export function flatArray(arr) {
  return arr.reduce((a, b) => a.concat(b), []);
}

export function isTextOverflowing(element) {
  return element.offsetWidth < element.scrollWidth;
}

export function getClosestComponent(parent, name) {
  if (parent) {
    if (parent.$options.name === name) {
      return parent;
    } else {
      return getClosestComponent(parent.$parent, name);
    }
  } else {
    return undefined;
  }
}

export function getPropertyValueFromString(obj, path) {
  let translation = "";
  for (path of path.split(".")) {
    if (!translation) translation = obj;
    if (translation[path]) translation = translation[path];
    else {
      translation = "";
      break;
    }
  }
  return translation ? translation : path;
}

export function normalizeString(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

export function removeWildcard(str) {
  return str.endsWith(DQL_SPECIAL_CHARACTERS.WILDCARD)
    ? str.slice(0, str.length - 1)
    : str;
}

export function splitSentence(sentence) {
  const words = [];
  let inQuotedWord = false;
  let startIndex = 0;
  if (sentence === "") {
    words.push("");
  } else {
    for (let index = 0; index < sentence.length; index++) {
      const character = sentence.charAt(index);
      const nextCharacter = sentence.charAt(index + 1);
      if (
        (character === DQL_SPECIAL_CHARACTERS.SPACE &&
          nextCharacter === DQL_SPECIAL_CHARACTERS.QUOTE &&
          !inQuotedWord) ||
        (character === DQL_SPECIAL_CHARACTERS.QUOTE &&
          nextCharacter === DQL_SPECIAL_CHARACTERS.SPACE &&
          inQuotedWord)
      ) {
        inQuotedWord = !inQuotedWord;
      }
      if (
        !nextCharacter ||
        (nextCharacter === DQL_SPECIAL_CHARACTERS.SPACE && !inQuotedWord) ||
        (character === DQL_SPECIAL_CHARACTERS.QUOTE &&
          nextCharacter === DQL_SPECIAL_CHARACTERS.SPACE &&
          inQuotedWord)
      ) {
        words.push(sentence.substring(startIndex, index + 1));
        startIndex = index + 2;
      }
    }
  }
  return words;
}

export function stringsSimilarity(string1, string2) {
  const longerString = string1 >= string2 ? string1 : string2;
  const shorterString = string1 >= string2 ? string2 : string1;
  const longerLength = longerString.length;
  if (longerLength === 0) {
    return 1.0;
  }
  return (
    (longerLength - stringsSimilarityDistance(longerString, shorterString)) /
    parseFloat(longerLength)
  );
}

function stringsSimilarityDistance(longerString, shorterString) {
  const costs = new Array();
  longerString = longerString.toLowerCase();
  shorterString = shorterString.toLowerCase();
  for (let indexLonger = 0; indexLonger <= longerString.length; indexLonger++) {
    let lastValue = indexLonger;
    for (
      let indexShorter = 0;
      indexShorter <= shorterString.length;
      indexShorter++
    ) {
      if (indexLonger == 0) costs[indexShorter] = indexShorter;
      else {
        if (indexShorter > 0) {
          let newValue = costs[indexShorter - 1];
          if (
            longerString.charAt(indexLonger - 1) !=
            shorterString.charAt(indexShorter - 1)
          )
            newValue =
              Math.min(Math.min(newValue, lastValue), costs[indexShorter]) + 1;
          costs[indexShorter - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (indexLonger > 0) costs[shorterString.length] = lastValue;
  }
  return costs[shorterString.length];
}
